<template>
  <div class="h-full">
    <div
      class="w-full flex justify-between px-8 p-6 border-b-2 border-zt-dark-200"
    >
      <h1 class="text-2xl font-bold leading-loose">
        {{ $t('message.abm.folders.folderList.title') }}
      </h1>
      <zt-button
        outlined
        icon="circle-plus-solid"
        class="zt-button-h"
        @click="gotoCreateFolder"
        data-vs-button="gotoCreateFolder"
      >
        {{ $t('message.abm.folders.folderList.buttonPrimary') }}
      </zt-button>
    </div>
    <list-table
      :folder-list-items="folderList"
      :current-page="currentPage"
      :items-per-page="perPage"
      :total-records="total"
      @paginate-change="updateFoldersTable"
      :column-header="columnHeader"
      :loading-rows="isLoading"
    />
  </div>
</template>
<script>
import ListTable from './table/ListTable'
import { mapActions } from 'vuex'
import { isEmpty, forEach } from 'lodash'
export default {
  name: 'FoldersList',
  components: { ListTable },
  inject: ['setPagination', 'paginationStore'],
  data() {
    return {
      folderList: [],
      currentPage: 1,
      perPage: 10,
      total: null,
      isLoading: false,
      columnHeader: [
        {
          title: this.$t('message.abm.folders.folderList.header.name'),
          className: 'w-2/5',
          width: ''
        },
        {
          title: this.$t('message.abm.folders.folderList.header.visible'),
          className: 'text-center',
          width: '132px'
        },
        {
          title: this.$t('message.abm.folders.folderList.header.signature'),
          className: 'text-center',
          width: '132px'
        },
        {
          title: this.$t('message.abm.folders.folderList.header.ephemeral'),
          className: 'text-center',
          width: '132px'
        }
      ]
    }
  },
  methods: {
    ...mapActions({
      getFolderList: 'folderSettings/getListFoldersAvailable'
    }),
    gotoCreateFolder() {
      this.$router.push({ name: 'create' })
    },
    async updateFoldersTable(paginate) {
      try {
        this.isLoading = true
        this.folderList = []
        const pagination = `${paginate.perPage},${paginate.currentPage},0`
        const list = await this.getFolderList({ pagination })
        this.currentPage = paginate.currentPage
        this.perPage = paginate.perPage
        this.total = list.pagination.total
        this.setPagination({
          currentPage: paginate.currentPage,
          perPage: paginate.perPage,
          total: this.total
        })
        forEach(list.data, (item) => {
          let itemObject = {
            id: item.id,
            name: item.name,
            attr1: item.visible,
            attr2: item.firmable,
            attr3: item.efimero,
            amount: item.subfolders.length,
            toFirstRoute: {
              name: 'update',
              params: { id: item.id }
            },
            toSecondRoute: {
              name: 'subFolderList',
              params: { id: item.id, folderName: item.name }
            },
            update_at: item.update_at,
            update_fullname: item.update_fullname
          }
          this.folderList.push(itemObject)
        })
        this.$emit('isEmptyList', isEmpty(list))
        this.isLoading = false
      } catch (e) {
        this.$emit('isEmptyList', true)
        this.isLoading = false
      }
    }
  },
  created() {
    this.currentPage = this.paginationStore.pagination.currentPage
    this.perPage = this.paginationStore.pagination.perPage
  }
}
</script>

<style scoped lang="scss">
::v-deep .zt-button {
  & > span > i {
    font-size: 22px;
  }
  .zt-button-text {
    margin-left: 0.68rem !important;
    font-size: 1rem;
  }
  color: #4f41a3 !important;
}
</style>
